import { Navigate, useParams } from "react-router-dom";

import { buildItineraryListPreviewPath } from "..";

/** 兼容旧预览地址并转到线路列表的统一预览抽屉。 */
export function ItineraryPreviewPage() {
  const { itineraryId = "" } = useParams();
  return <Navigate replace to={buildItineraryListPreviewPath(itineraryId)} />;
}
